import { AppRouteProps } from "@bsm/component";
import React from "react";
import { ProjectDayOffViewsSummaryRoutes } from "./views/summary/ProjectDayOffViewsSummaryRoutes";
import { ProjectDayOffViewsDemandRoutes } from "./views/demand/ProjectDayOffViewsDemandRoutes";
import { ProjectDayOffViewsCalendarRoutes } from "./views/calendar/ProjectDayOffViewsCalendarRoutes";
import { ProjectDayOffMissingRoutes } from "./views/missing/ProjectDayOffMissingRoutes";
const ProjectDayOffContainer = React.lazy(
    () => import("./container/ProjectDayOffContainer")
);

export const ProjectDayOffRoutes: Array<AppRouteProps> = [
    {
        path: "dayoff",
        title: "BSMRH.Project.DayOff.Management.Label",
        element: <ProjectDayOffContainer />,
        roles: ["TIMEOFF"],
        children: [
            ...ProjectDayOffViewsDemandRoutes,
            ...ProjectDayOffViewsSummaryRoutes,
            ...ProjectDayOffViewsCalendarRoutes,
            ...ProjectDayOffMissingRoutes
        ],
    },
];
